import { render } from "./NeeraOutlineArrowButton.vue?vue&type=template&id=edf167cc"
import script from "./NeeraOutlineArrowButton.vue?vue&type=script&lang=js"
export * from "./NeeraOutlineArrowButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pongsakornsomsri/workspace/neera-retreat-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__